
import React from 'react'
import { component_tool } from '../../../../tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self) => {
  const columns = [
    {
      title: "经销商规模",
      name: "scale",
      dataIndex: "scale",
      tableItem: {},
    },
    {
      title: "人数",
      name: "number",
      dataIndex: "number",
      tableItem: {},
    },
    {
      title: '操作',
      tableItem: {
        width: 220,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip="编辑" onClick={e => self.updateScale(record)}>编辑</WizButton>
            <WizDivider type="vertical" />
            <WizButton tooltip="删除" onClick={e => self.deleteScale(record.id)}>删除</WizButton>
          </WizDataTable.Oper>
        )
      }
    }
  ];

  return columns
}
